import React, { useState } from "react";
import { colors } from "../../../../utils";
import { ASSETS } from "../../../../utils/config";
import RenamePaletteDialog from "./RenamePaletteDialog";
import MenuPopup from "../../../MenuPopup";
import TextView from "../../../TextView";
import * as Styled from "./styles";

export default function LibraryItem({
  palette,
  selectedMenuId,
  setSelectedMenuId,
  type,
  paletteType,
  handleDeletePalette,
  handleSavePalette,
  handleOnClickPalette,
  handleRenamePalette,
}) {
  const { palette_name, id, selected } = palette;
  const [showRenameModal, setShowRenameModal] = useState(false);
  
  const toggleDropdown = () =>
    selectedMenuId === id ? setSelectedMenuId(null) : setSelectedMenuId(id);

  const handleClose = () => {
    setSelectedMenuId(null);
  };

  const handleRename = () => {
    setShowRenameModal(true);
    setSelectedMenuId(null); // Close the menu when opening modal
  };

  const handleConfirmRename = (newTitle) => {
    handleRenamePalette({
      paletteType,
        paletteId: id,
        newTitle: newTitle,
        type
      });
    setShowRenameModal(false);
  };

  const handleCloseRename = () => {
    setShowRenameModal(false);
  };

  const circles = palette ? [...palette?.colors] : [];

  const menuItems = [
    {
      label: "Rename",
      icon: (
        <img
          src={ASSETS.edit}
          className="img-fluid"
          alt="Edit"
          width="15"
          height="15"
        />
      ),
      action: (data) => handleRename(data),
    },
   !!handleSavePalette ? {
      label: "Save to Library",
      icon: (
        <img
          src={ASSETS.OnlySave}
          className="img-fluid"
          alt="Edit"
          width="15"
          height="15"
        />
      ),
      action: (data) => handleSavePalette(data),
    } : null,
    {
      label: "Delete",
      icon: (
        <img
          src={ASSETS.delete_icon}
          className="img-fluid"
          alt="Edit"
          width="15"
          height="15"
        />
      ),
      action: (data) => handleDeletePalette(data, type),
    },
  ].filter(Boolean);

  return (
    <>
      <div
        style={{
         padding:10,
          border: `1px solid`,
          borderRadius: 8,
          alignItems: "center",
          cursor: "pointer",
          borderColor:selected ? colors.PrimaryPurple : colors.lightBorder,
          height:75,
          marginBottom:8
        
        }}
        onClick={()=>handleOnClickPalette(palette,type)}
      >
        <div style={{
          display:"grid",
          gridTemplateColumns:"1fr auto",
          marginBottom:16
        }}>
        <TextView style={{ WebkitLineClamp: 1 }}>
          {palette_name.replace('"', "")}
        </TextView>
        <MenuPopup
          open={selectedMenuId == id}
          setOpen={toggleDropdown}
          data={{ palette }}
          menuItems={menuItems}
          handleClose={handleClose}
        />
        </div>
        <Styled.CircleRow style={{width:circles.length>5 ? 250 : 70, alignItems:"center",display:"flex" }}>
          {circles.reverse().map((color, index) => (
            <Styled.CircleBorder style={{width:22,height:22}} key={index} right={index * 12} index={index}>
              <Styled.Circle style={{ backgroundColor: color.hex }} />
            </Styled.CircleBorder>
          ))}
        </Styled.CircleRow>
       
      </div>

      <RenamePaletteDialog
        open={showRenameModal}
        onClose={handleCloseRename}
        onConfirm={handleConfirmRename}
        initialValue={palette_name}
      />
    </>
  );
}
